"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var public_api_1 = require("@l2p/public-api");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var LeavingSoSoon = function (_a) {
    var onClose = _a.onClose, onCancel = _a.onCancel, leavingBonus = _a.leavingBonus;
    var t = (0, next_intl_1.useTranslations)();
    var bonusesForUser = (0, swr_hooks_1.useBonusesByType)(public_api_1.BonusType.Deposit).data;
    var config = (0, swr_hooks_1.useConfig)();
    var leavingSoonBonus = (0, react_1.useMemo)(function () {
        return (config === null || config === void 0 ? void 0 : config.showLeavingSoonBonusBySlug)
            ? bonusesForUser === null || bonusesForUser === void 0 ? void 0 : bonusesForUser.find(function (bonus) { var _a; return (_a = bonus === null || bonus === void 0 ? void 0 : bonus.slug) === null || _a === void 0 ? void 0 : _a.includes('leaving-soon'); })
            : null;
    }, [config === null || config === void 0 ? void 0 : config.showLeavingSoonBonusBySlug, bonusesForUser]);
    return (react_1.default.createElement(ui_components_1.Modal, { className: styles_module_scss_1.default.modal, width: "480px", height: "auto", portalNodeId: "modal", saveSize: true, onClose: onCancel },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title, dangerouslySetInnerHTML: {
                    __html: t.raw('translation.leavingSoSoonTitle'),
                } }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.description, dangerouslySetInnerHTML: {
                    __html: t.raw('translation.leavingSoSoonDescr'),
                } }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.bonus },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusBonus }, (leavingSoonBonus === null || leavingSoonBonus === void 0 ? void 0 : leavingSoonBonus.title) ||
                    (leavingBonus === null || leavingBonus === void 0 ? void 0 : leavingBonus.title) ||
                    t('promotions.welcomeBonus'))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.description, dangerouslySetInnerHTML: {
                    __html: t.raw('translation.leavingSoSoonDescr2'),
                } }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                react_1.default.createElement(ui_components_1.FixedButton, { onClick: onClose }, t('translation.leavingSoSoonFund')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.leavingSoSoon, onClick: onCancel }, t('translation.leavingSoSoonClose'))))));
};
exports.default = LeavingSoSoon;
